export default {
  startsOnNewPage: 'Auf neuer Seite beginnen',
};
